<div class="anpp">
  <div class="content">
    <div class="content-panel" *ngIf="fonction">
      <div class="title-bar">
        <h4>
          {{ title | translate }}
        </h4>
      </div>

      <form *ngIf="formGroup" [formGroup]="formGroup" #form="ngForm" (submit)="submit()" novalidate>

        <div class="m-3">
          <div class="row">
          <div class="mb-3 col-lg-4">
            <label class="form-label" for="code" translate>page.valeur_parametrable.form.label.code</label>

            <input type="text" id="code" formControlName="code"
              [ngClass]="{'is-invalid': form.submitted && code.invalid}" class="form-control" />

            <ng-container *ngIf="form.submitted">
              <div *ngIf="code.errors?.required" class="form-error" translate>label.obligatoire</div>
            </ng-container>
          </div>
          <div class="mb-3 col-lg-8">
            <label class="form-label" for="libelle" translate>page.valeur_parametrable.form.label.libelle</label>

            <input type="text" id="libelle" formControlName="libelle"
              [ngClass]="{'is-invalid': form.submitted && libelle.invalid}" class="form-control" />

            <ng-container *ngIf="form.submitted">
              <div *ngIf="libelle.errors?.required" class="form-error" translate>label.obligatoire</div>
            </ng-container>
          </div>
        </div></div>

        <div class="actions-bar justify-content-between">
          <button class="btn btn-primary" *ngIf="!creation" [routerLink]="'../..'" translate>label.retour</button>
          <button class="btn btn-primary" *ngIf="creation" [routerLink]="'../'" translate>label.retour</button>

          <button type="submit" class="btn btn-primary" translate>{{!creation
            ? 'label.suivant': 'label.valider'}}</button>
        </div>
      </form>
    </div>
  </div>
</div>

